import { Controller, useFormContext } from "react-hook-form";

import { AiNodeV2Form } from "src/aiNode/types";
import { Card } from "src/base-components/Card";
import { CodeEditor } from "src/base-components/CodeInput/CodeEditor";
import { FormItem } from "src/base-components/FormItem";

type PropsT = {
  immutable: boolean;
};

export const PromptEditorV2: React.FC<PropsT> = ({ immutable }) => {
  const { control } = useFormContext<AiNodeV2Form>();

  return (
    <Card className="w-full pb-4 pt-4">
      <FormItem>
        <FormItem.Label
          className="mb-2"
          description="Describe the task you want the AI to perform. Use $data to include dynamic values from your Decision Flow"
          isRequired
        >
          Message
        </FormItem.Label>
        <Controller
          control={control}
          name="prompts.messages.0.content.0.text.expression"
          render={({ field }) => (
            <div className="h-80">
              <CodeEditor
                disabled={immutable}
                language="prompt"
                placeholder="e.g. Extract the `credit_score` and `incorporation_date` from this credit report: $data.credit_report"
                value={field.value ?? ""}
                lineWrapping
                onChange={field.onChange}
              />
            </div>
          )}
        />
      </FormItem>
    </Card>
  );
};
